module.exports = __webpack_public_path__ + "assets/images/limited_activity_r.c9e4f96d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/limited_activity_r.png
// module id = 753
// module chunks = 1